// composables/useAuthModal.ts
import { ref } from "vue";

export const showLogin = ref(false);
export const showSignup = ref(false);

export const useAuthModal = () => {
  const openLogin = () => {
    showLogin.value = true;
    showSignup.value = false;
  };
  const openSignup = () => {
    showSignup.value = true;
    showLogin.value = false;
  };
  const closeLogin = () => (showLogin.value = false);
  const closeSignup = () => (showSignup.value = false);

  return {
    showLogin,
    showSignup,
    openLogin,
    openSignup,
    closeLogin,
    closeSignup,
  };
};
